import { render, staticRenderFns } from "./News4.vue?vue&type=template&id=e373cfd4"
import script from "./News4.vue?vue&type=script&lang=ts"
export * from "./News4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports